export default __webpack_public_path__ + "static/media/default-dark.51aeceb8.png";